import { cloneDeep } from 'lodash'
import pos from '@/components/apps/pos/sidebar.json'
import productService from '@/components/apps/items/sidebar.json'
import inventory from '@/components/apps/inventory/sidebar.json'
import purchases from '@/components/apps/purchases/sidebar.json'
import sales from '@/components/apps/sales/sidebar.json'
import expenses from '@/components/apps/expenses/sidebar.json'
import report from '@/components/apps/report/sidebar.json'
import contact from '@/components/apps/contact/sidebar.json'
import accounts from '@/components/apps/accounts/sidebar.json'
import hrm from '@/components/apps/hrm/sidebar.json'
import payroll from '@/components/apps/payroll/sidebar.json'

export const mapSidebar = {
  1: pos,
  2: productService,
  3: inventory,
  4: purchases,
  5: sales,
  6: expenses,
  8: report,
  11: contact,
  12: accounts,
  13: hrm,
  14: payroll,
}

export const getSidebar = (appId) => {
  return mapSidebar[appId]
}

export const getLink = ({ moduleId, subModuleId, sidebar }) => {
  const module = sidebar.find((item) => item.moduleId === moduleId)
  const hasSubMenus = module.submenus && !!module.submenus.length
  if (!subModuleId) {
    if (module.router) {
      return module.router.name
    } else if (hasSubMenus) {
      return module.submenus[0].router.name
    }
  }
  for (const subModule of module.submenus) {
    if (subModule.subModuleId === subModuleId) {
      return subModule.router.name
    }
  }
  return null
}

export const getModuleDefaultLink = ({ appId, permissions = [] }) => {
  const app = permissions.find((item) => item.app_id === appId)
  const sidebar = getSidebar(appId)
  const hasAppPermission = !!app
  const hasSidebar = !!sidebar
  if (hasAppPermission && hasSidebar) {
    const modules = cloneDeep(app.modules)
    for (const moduleItem of modules) {
      const moduleId = moduleItem.module_id
      const hasSubModules = moduleItem.sub_modules && !!moduleItem.sub_modules.length
      if (hasSubModules) {
        for (const subModuleItem of moduleItem.sub_modules) {
          const hasSomePermission = Object.keys(subModuleItem.action).some((key) => subModuleItem.action[key] === true)
          if (!hasSomePermission) continue
          const subModuleId = subModuleItem.sub_module_id
          return getLink({ moduleId, subModuleId, sidebar })
        }
      } else {
        const hasSomePermission = Object.keys(moduleItem.action).some((key) => moduleItem.action[key] === true)
        if (!hasSomePermission) continue
        return getLink({ moduleId, subModuleId: null, sidebar })
      }
    }
  }
  return null
}



// WEBPACK FOOTER //
// ./src/helpers/sidebar.js